import { isBlank } from '@/utils/validate'
import { apiGetStaffManufacturerDetail } from '@/apis/organizeStaff.api'

export default {
	actions: {
		async applyLoginResult({ commit }, res) {
			const { accessToken, permissions = [], functionalCodes, waterRegionCode, ...userInfo } = res
			const permissionCodes = functionalCodes || permissions.map(item => item.permissionCode)
			commit('user/SET_TOKEN', accessToken, { root: true })
			commit('user/SET_PERMISSIONS', permissionCodes, { root: true })
			let defaultWaterRegionCode = undefined
			if (!isBlank(waterRegionCode)) {
				const codes = waterRegionCode.split(',')
				let minLenCode = codes[0]
				for (let i = 1; i < codes.length; i++) {
					if (minLenCode.length > codes[i].length) {
						minLenCode = codes[i]
					}
				}
				defaultWaterRegionCode = minLenCode
			}
			const data = userInfo.staffId ? await apiGetStaffManufacturerDetail(userInfo.staffId) : null
			commit(
				'user/SET_USER_INFO',
				{
					...userInfo,
					waterRegionCode,
					tenantType: isBlank(userInfo.tenantType) ? '0' : userInfo.tenantType,
					defaultWaterRegionCode,
					manufacturerId: data?.manufacturerId || 0,
					manufacturerName: data?.manufacturerName || '租户平台账号',
				},
				{ root: true },
			)
		},
	},
}
